module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.0.0.box.309.118.1262.247.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.20.0.0.box.310.118.1148.176.q.90"
    }
  }, [_vm._v("CHOCOLATE-CHOCOLATE-CHOCOLATE CAKE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.20.0.1.box.309.316.1262.49.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("From ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pirate's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("House ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("restaurant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Savannah, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Georgia ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.20.1.0.box.312.494.1080.263.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0015.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.2.0.box.313.864.1267.922.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.2.0.box.313.864.1267.922.q.50"
    }
  }, [_vm._v("Have butter and eggs at room temperature. Line bottoms of 3 8-inch round cake pans with wax paper; grease paper and flour. Preheat oven to 350°. Cream butter and sugar until light and fluffy. Beat in egg yolks one at a time; beat in melted chocolate. Sift flour and baking soda together. Beat in alternately with buttermilk, starting and ending with flour. Beat in vanilla. Beat egg whites until stiff but not dry. Beat one-fourth of the egg whites into chocolate mixture to lighten it, then fold chocolate mixture into egg whites gently but thoroughly. The chocolate batter will be very heavy and won't want to cooperate, but be firm. Divide batter among pans; smooth tops and bake for 30 to 35 minutes, until tops spring back when lightly touched and cakes shrink from sides of pans. Cool on wire racks and turn out. You may have to slip a finger under the wax paper to get it started. Fill and ice. Serves 12 or more.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.20.3.0.box.314.1894.1189.319.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.7.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0016.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.7.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.4.0.box.314.2314.1262.106.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.4.0.box.314.2314.1262.106.q.60"
    }
  }, [_vm._v("Mix dry ingredients. Whisk in egg until smooth. Melt chocolate in milk in a heavy saucepan, stirring constantly."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.0.0.box.230.235.1259.398.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _vm._v("\nGradually pour milk into egg mixture, whisking rapidly and constantly. Return mixture to saucepan and cook, stirring constantly with a wooden spoon, until mixture thickens and comes to a boil. Remove from heat; beat in butter and vanilla. Pour into a bowl, place a piece of plastic wrap directly on the surface of the filling, and refrigerate until cool. Use between layers of cake.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.0.0.box.230.235.1259.398.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.21.1.0.box.230.739.1114.267.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0017.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.21.2.0.box.226.1100.1264.681.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.2.0.box.226.1100.1264.568.q.60"
    }
  }, [_vm._v("Melt chocolate and butter in a large, heavy saucepan over low heat, stirring constantly. Dissolve flour in part of the milk; add milk, flour and sugar to chocolate, bring to a boil, stirring frequently, and boil until mixture reaches soft ball stage on a candy thermometer (234°). Remove from heat, stir in vanilla, and beat with an electric mixer until icing becomes just thick enough to spread. Do not let it harden too much. If icing does become too hard, beat in a little milk. Ice entire outside of cake. Dip spatula or knife in hot water to smooth icing.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.2.1.box.226.1678.1259.103.q.60"
    }
  }, [_vm._v("Note: Don't let the length of this recipe intimidate you. For true chocolate lovers, it is well worth the effort.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.3.0.box.228.1852.1265.270.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.3.0.box.228.1852.1265.270.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.4.0.0"
    }
  }), _vm._v("This ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pirate's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("House ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Savannah, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Georgia. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("restaurant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("located ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("building, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("which ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("originally ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("an ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("inn ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("visiting ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("seamen, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("built ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mid-1")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("700s. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("It ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recognized ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("by ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("American ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Museum ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Society ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("an ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("authentic ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("house ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("museum. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-930d42f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0018.vue
// module id = 66
// module chunks = 0